<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>订货明细</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡：货品行级明细流水（单头视角见「订货数据」页） -->
    <el-card class="main-card">
      <div slot="header" class="toolbar">
        <span class="card-header">
          订货明细
          <span class="header-summary">货品行级流水 · 归集口径与订货数据一致（单据编码 → 门店映射）</span>
        </span>
        <span class="toolbar-tip">点击单号可跳转「订货数据」定位所属单据（含对账校验）</span>
      </div>

      <!-- 指标卡：4 张（随筛选联动，平台随单选切换） -->
      <div v-if="activeTab === 'meituan'" class="stat-cards">
        <div class="stat-card">
          <div class="stat-card-num">{{ meituan.stats.rows || 0 }}</div>
          <div class="stat-card-label">明细行数</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-num">{{ meituan.stats.qtySum || 0 }}</div>
          <div class="stat-card-label">数量合计</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-num">{{ fmtMoney(meituan.stats.amountSum) }}</div>
          <div class="stat-card-label">金额合计（元）</div>
        </div>
        <div class="stat-card" :class="{ warn: (meituan.stats.unassigned || 0) > 0 }">
          <div class="stat-card-num">{{ meituan.stats.unassigned || 0 }}</div>
          <div class="stat-card-label">未归属行数</div>
        </div>
      </div>
      <div v-else class="stat-cards">
        <div class="stat-card">
          <div class="stat-card-num">{{ shiheng.stats.rows || 0 }}</div>
          <div class="stat-card-label">明细行数</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-num">{{ shiheng.stats.qtySum || 0 }}</div>
          <div class="stat-card-label">数量合计</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-num">{{ fmtMoney(shiheng.stats.amountSum) }}</div>
          <div class="stat-card-label">金额合计（元）</div>
        </div>
        <div class="stat-card" :class="{ warn: (shiheng.stats.unassigned || 0) > 0 }">
          <div class="stat-card-num">{{ shiheng.stats.unassigned || 0 }}</div>
          <div class="stat-card-label">未归属行数</div>
        </div>
      </div>

      <!-- 筛选行：平台单选切换 + 各平台独立筛选状态 -->
      <div class="filter-row">
        <el-radio-group v-model="activeTab" size="medium" @change="handleTabChange">
          <el-radio-button label="meituan">美团管家</el-radio-button>
          <el-radio-button label="shiheng">食亨系统</el-radio-button>
        </el-radio-group>
        <template v-if="activeTab === 'meituan'">
          <el-date-picker
            v-model="meituan.filterDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="medium"
            style="width: 260px; margin-left: 10px;"
            :clearable="false"
            @change="handleFilterChange('meituan')"
          ></el-date-picker>
          <el-input v-model="meituan.filterProject" placeholder="项目名" clearable size="medium" style="width: 140px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('meituan')" @clear="handleFilterChange('meituan')"></el-input>
          <el-input v-model="meituan.filterKeyword" placeholder="货品/单号/订货方/编码" clearable size="medium" style="width: 200px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('meituan')" @clear="handleFilterChange('meituan')"></el-input>
          <el-select v-model="meituan.filterCategory" placeholder="货品类别" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('meituan')">
            <el-option v-for="c in categoryOptions" :key="c" :label="c" :value="c"></el-option>
          </el-select>
          <el-select v-model="meituan.filterOwner" placeholder="归属状态" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('meituan')">
            <el-option label="已归属" value="assigned"></el-option>
            <el-option label="未归属" value="unassigned"></el-option>
          </el-select>
          <el-button type="primary" size="medium" style="margin-left: 10px;" @click="handleFilterChange('meituan')">查询</el-button>
          <el-button size="medium" icon="el-icon-download" style="margin-left: 10px;" @click="handleExport('meituan')">导出</el-button>
        </template>
        <template v-else>
          <el-date-picker
            v-model="shiheng.filterDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="medium"
            style="width: 260px; margin-left: 10px;"
            :clearable="false"
            @change="handleFilterChange('shiheng')"
          ></el-date-picker>
          <el-input v-model="shiheng.filterProject" placeholder="项目名" clearable size="medium" style="width: 140px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('shiheng')" @clear="handleFilterChange('shiheng')"></el-input>
          <el-input v-model="shiheng.filterKeyword" placeholder="货品/单号/订货方/编码" clearable size="medium" style="width: 200px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('shiheng')" @clear="handleFilterChange('shiheng')"></el-input>
          <el-select v-model="shiheng.filterCategory" placeholder="货品类别" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('shiheng')">
            <el-option v-for="c in categoryOptions" :key="c" :label="c" :value="c"></el-option>
          </el-select>
          <el-select v-model="shiheng.filterOwner" placeholder="归属状态" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('shiheng')">
            <el-option label="已归属" value="assigned"></el-option>
            <el-option label="未归属" value="unassigned"></el-option>
          </el-select>
          <el-button type="primary" size="medium" style="margin-left: 10px;" @click="handleFilterChange('shiheng')">查询</el-button>
          <el-button size="medium" icon="el-icon-download" style="margin-left: 10px;" @click="handleExport('shiheng')">导出</el-button>
        </template>
        <span class="toolbar-tip" style="margin-left: auto;">共 {{ activeTab === 'meituan' ? meituan.total : shiheng.total }} 条</span>
      </div>

      <!-- 明细表：美团 -->
      <el-table v-if="activeTab === 'meituan'" v-loading="meituan.loading" :data="meituan.list" border stripe max-height="560" :row-class-name="rowClassName">
        <el-table-column label="#" type="index" width="50" :index="i => indexMethod('meituan', i)"></el-table-column>
        <el-table-column label="单号 / 单据日期" width="170">
          <template slot-scope="scope">
            <div class="project-name"><span class="link-text" @click="goOrderList(scope.row)">{{ scope.row.orderKey }}</span></div>
            <div class="text-content">制单 {{ scope.row.orderDate }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货方" min-width="150">
          <template slot-scope="scope">
            <div class="project-name">{{ scope.row.orgName }}</div>
            <div class="text-content">{{ scope.row.orgCode }}</div>
          </template>
        </el-table-column>
        <el-table-column label="归属项目" min-width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.owner">
              <div class="project-name">
                {{ scope.row.owner.projectName }}
                <el-tag v-if="scope.row.owner.via === 'history'" size="mini" type="info" style="margin-left: 2px;">历史归属</el-tag>
              </div>
            </template>
            <template v-else>
              <span class="unassigned-text">未归属</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="货品编码" width="100"></el-table-column>
        <el-table-column prop="goodsName" label="货品名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="category" label="类别" width="90"></el-table-column>
        <el-table-column prop="standard" label="规格" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unitName" label="单位" width="60" align="center"></el-table-column>
        <el-table-column label="数量" width="70" align="right">
          <template slot-scope="scope">{{ scope.row.qty }}</template>
        </el-table-column>
        <el-table-column label="单价（元）" width="100" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.price) }}</template>
        </el-table-column>
        <el-table-column label="金额（元）" width="100" align="right">
          <template slot-scope="scope">
            <span class="money-text">{{ fmtMoney(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发货仓库" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.warehouse">{{ scope.row.warehouse }}</span>
            <span v-else class="muted-text">未分配</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 明细表：食亨 -->
      <el-table v-else v-loading="shiheng.loading" :data="shiheng.list" border stripe max-height="560" :row-class-name="rowClassName">
        <el-table-column label="#" type="index" width="50" :index="i => indexMethod('shiheng', i)"></el-table-column>
        <el-table-column label="单号 / 单据日期" width="170">
          <template slot-scope="scope">
            <div class="project-name"><span class="link-text" @click="goOrderList(scope.row)">{{ scope.row.orderKey }}</span></div>
            <div class="text-content">下单 {{ scope.row.orderDate }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货方" min-width="150">
          <template slot-scope="scope">
            <div class="project-name">{{ scope.row.orgName }}</div>
            <div class="text-content">{{ scope.row.orgCode }}</div>
          </template>
        </el-table-column>
        <el-table-column label="归属项目" min-width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.owner">
              <div class="project-name">
                {{ scope.row.owner.projectName }}
                <el-tag v-if="scope.row.owner.via === 'history'" size="mini" type="info" style="margin-left: 2px;">历史归属</el-tag>
              </div>
            </template>
            <template v-else>
              <span class="unassigned-text">未归属</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="货品编码" width="100"></el-table-column>
        <el-table-column prop="goodsName" label="货品名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="category" label="类别" width="90"></el-table-column>
        <el-table-column prop="standard" label="规格" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unitName" label="单位" width="60" align="center"></el-table-column>
        <el-table-column label="数量" width="70" align="right">
          <template slot-scope="scope">{{ scope.row.qty }}</template>
        </el-table-column>
        <el-table-column label="单价（元）" width="100" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.price) }}</template>
        </el-table-column>
        <el-table-column label="金额（元）" width="100" align="right">
          <template slot-scope="scope">
            <span class="money-text">{{ fmtMoney(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发货仓库" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.warehouse">{{ scope.row.warehouse }}</span>
            <span v-else class="muted-text">—</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-if="activeTab === 'meituan'"
        style="margin-top: 15px; text-align: right;"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="meituan.total"
        :current-page.sync="meituan.pagenum"
        :page-sizes="[20, 50, 100]"
        :page-size.sync="meituan.pagesize"
        @current-change="fetchList('meituan')"
        @size-change="handleSizeChange('meituan')"
      ></el-pagination>
      <el-pagination
        v-else
        style="margin-top: 15px; text-align: right;"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="shiheng.total"
        :current-page.sync="shiheng.pagenum"
        :page-sizes="[20, 50, 100]"
        :page-size.sync="shiheng.pagesize"
        @current-change="fetchList('shiheng')"
        @size-change="handleSizeChange('shiheng')"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'FinanceOrderDetail',
  data () {
    return {
      activeTab: 'meituan',
      // 货品类别选项（静态固定列表，后续可改为数据聚合）
      categoryOptions: ['米面粮油', '冻品', '调味品', '酒水饮料', '包装耗材', '蔬果生鲜'],
      // 美团明细（服务端分页；各平台筛选状态独立保留）
      meituan: {
        list: [],
        total: 0,
        stats: {},
        loading: false,
        filterDateRange: [],
        filterKeyword: '',
        filterProject: '',
        filterCategory: '',
        filterOwner: '',
        pagenum: 1,
        pagesize: 20
      },
      // 食亨明细（服务端分页）
      shiheng: {
        list: [],
        total: 0,
        stats: {},
        loading: false,
        filterDateRange: [],
        filterKeyword: '',
        filterProject: '',
        filterCategory: '',
        filterOwner: '',
        pagenum: 1,
        pagesize: 20
      }
    }
  },
  created () {
    // 默认查最近 7 天（含今天；跨日单/补采场景下比单日默认更不易漏看）
    const fmtDay = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    const weekRange = [fmtDay(new Date(Date.now() - 6 * 86400000)), fmtDay(new Date())]
    this.meituan.filterDateRange = weekRange
    this.shiheng.filterDateRange = weekRange
    this.fetchList('meituan')
    this.fetchList('shiheng')
  },
  watch: {
  },
  methods: {
    /**
     * 金额格式化：两位小数 + 千分位
     */
    fmtMoney (v) {
      if (v === null || v === undefined || isNaN(v)) return '—'
      return Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    /**
     * 日期格式化（东八区，YYYY-MM-DD）：后端返回 ISO 字符串，勿直接截取前 10 位（UTC 会差 8 小时）
     */
    fmtDate (v) {
      return v ? new Date(v).toLocaleDateString('sv-SE') : ''
    },

    /**
     * 分页序号（跨页连续，按平台各自计数）
     */
    indexMethod (platform, index) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      return (st.pagenum - 1) * st.pagesize + index + 1
    },

    /**
     * 未归属行淡红背景
     */
    rowClassName ({ row }) {
      return row.owner ? '' : 'unassigned-row'
    },

    /**
     * 组装筛选参数（列表查询与导出共用，保证所见即所得）
     */
    _buildParams (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      const [startDate, endDate] = st.filterDateRange || []
      const params = { platform, pagenum: st.pagenum, pagesize: st.pagesize }
      if (startDate) params.startDate = startDate
      if (endDate) params.endDate = endDate
      if (st.filterKeyword.trim()) params.keyword = st.filterKeyword.trim()
      if (st.filterProject.trim()) params.project = st.filterProject.trim()
      if (st.filterCategory) params.category = st.filterCategory
      if (st.filterOwner) params.ownerType = st.filterOwner
      return params
    },

    /**
     * 加载明细流水（服务端分页 + 统计；DB 字段标准化为页面统一列：orderKey/orgName/qty/price/amount/warehouse）
     */
    async fetchList (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.loading = true
      try {
        const { data: res } = await this.$http.get('finance/orderDetail/list', { params: this._buildParams(platform) })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        const isMt = platform === 'meituan'
        st.list = (res.data.list || []).map(r => ({
          platform,
          orderKey: isMt ? r.orderSn : r.orderNo,
          orderDate: this.fmtDate(isMt ? r.createTime : r.purchaseTime),
          orgName: isMt ? r.applyOrgName : r.customerName,
          orgCode: isMt ? r.applyOrgCode : r.customerCode,
          owner: r.owner,
          code: isMt ? r.goodsSn : r.goodsCode,
          goodsName: r.goodsName,
          category: r.category,
          standard: r.standard,
          unitName: r.unitName,
          qty: isMt ? r.deliveryQuantity : r.orderQuantity,
          price: isMt ? r.deliveryPrice : r.price,
          amount: isMt ? r.deliveryMoney : r.subtotalAmount,
          warehouse: isMt ? r.deliveryWarehouseName : r.warehouseName
        }))
        st.total = res.data.total || 0
        st.stats = res.data.stats || {}
      } finally {
        st.loading = false
      }
    },

    /**
     * 平台单选切换：刷新目标平台（用户交互触发；筛选状态各平台独立保留）
     */
    handleTabChange (platform) {
      this.fetchList(platform)
    },

    /**
     * 筛选变化：回到第一页重新查询（列表与统计卡服务端联动）
     */
    handleFilterChange (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.pagenum = 1
      this.fetchList(platform)
    },

    /**
     * 每页条数变化：回到第一页重新查询
     */
    handleSizeChange (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.pagenum = 1
      this.fetchList(platform)
    },

    /**
     * 导出（所见即所得：与列表同筛选；后端生成 xlsx，独立「导出」权限）
     * 无权限/参数错误时后端返回 JSON（HTTP 200），需识别为错误而非落盘损坏文件（仓内 Dianpu 同模式）
     */
    async handleExport (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      if (!st.total) return this.$message.warning('当前筛选条件下无数据可导出')
      try {
        const { data } = await this.$http.get('finance/orderDetail/export', { params: this._buildParams(platform), responseType: 'blob' })
        if (data.type === 'application/json') {
          const err = JSON.parse(await data.text())
          return this.$message.error((err.meta && err.meta.msg) || '导出失败')
        }
        const [start, end] = st.filterDateRange || []
        const dateTag = start && end ? (start === end ? String(start) : `${start}_${end}`) : '全部'
        this._downloadBlob(data, `订货明细_${platform === 'meituan' ? '美团配送单明细' : '食亨销售单明细'}_${dateTag}.xlsx`)
      } catch (err) {
        this.$message.error('导出失败')
      }
    },

    /**
     * 通用的 Blob 文件下载方法
     */
    _downloadBlob (blob, filename) {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    /**
     * 反向钻取：跳转「订货数据」页并带平台、单号与日期范围（目标页按同日期定位单据，避免首屏空）
     */
    goOrderList (row) {
      const st = row.platform === 'meituan' ? this.meituan : this.shiheng
      const [startDate, endDate] = st.filterDateRange || []
      const query = { platform: row.platform, keyword: row.orderKey }
      if (startDate) query.startDate = startDate
      if (endDate) query.endDate = endDate
      this.$router.push({ path: '/finance/orderData', query })
    }
  }
}
</script>

<style scoped>
.main-card {
  margin-top: 20px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
}
.header-summary {
  font-size: 12px;
  font-weight: normal;
  color: #909399;
  margin-left: 12px;
}

.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-top: 12px;
  border-top: 1px solid #EBEEF5;
  flex-wrap: wrap;
  row-gap: 8px;
}

.toolbar-tip {
  color: #909399;
  font-size: 12px;
}

/* 表格内小字 */
.text-content {
  font-size: 12px;
  color: #909399;
}
.project-name {
  font-size: 13px;
  color: #303133;
}
.muted-text {
  color: #c0c4cc;
}
.money-text {
  color: #303133;
  font-weight: 500;
}

/* 单号跳转链接 */
.link-text {
  color: #409EFF;
  cursor: pointer;
  font-size: 13px;
}
.link-text:hover {
  text-decoration: underline;
}

/* 未归属 */
.unassigned-text {
  color: #F56C6C;
  font-size: 13px;
  font-weight: 500;
}
::v-deep .unassigned-row {
  background: #FEF0F0 !important;
}

/* 指标卡 */
.stat-cards {
  display: flex;
  gap: 12px;
}
.stat-card {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background: #FAFBFC;
  text-align: center;
}
.stat-card-num {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2;
  color: #303133;
}
.stat-card.warn .stat-card-num {
  color: #F56C6C;
}
.stat-card-label {
  font-size: 12px;
  color: #606266;
  margin-top: 2px;
}
</style>
